import { render, staticRenderFns } from "./AppMoney.vue?vue&type=template&id=1df51cfa&scoped=true"
import script from "./AppMoney.vue?vue&type=script&lang=js"
export * from "./AppMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df51cfa",
  null
  
)

export default component.exports